export function uiDescription(_a) {
    return [
        {
            componentId: 'productComparisonContainer',
            testId: 'productComparisonContainer',
            containerId: 'productComparison',
            componentType: 'TemplateComponent',
            componentTemplate: 'sectionTemplate',
            productId: ['general'],
            level: 0,
            order: 1,
            'header-content': '',
        },
        {
            componentId: 'compareList',
            testId: 'compareList',
            containerId: 'productComparisonContainer_content',
            componentType: 'CompareListComponent',
            productId: ['general', 'resultData'],
            level: 1,
            order: 1,
            initOnSwiper: true,
            onClickEvent: 'bss-compare-list-send-request-for-FinancialDetails-on-product-comparison',
            class: '',
        },
        {
            componentId: 'popupTermConditions',
            testId: 'popupTermConditions',
            componentType: 'PopupComponent',
            containerId: 'productComparisonContainer_content',
            componentTemplate: 'popupTextTemplate',
            level: 1,
            order: 2,
            productId: ['general'],
            tableData: true,
            showClass: 'bss-popup-custom-fade-in',
            hideClass: 'bss-popup-custom-fade-out',
            recalculateOnEvent: false,
            isInPopup: true,
            parentPopup: '',
            onClickEvent: 'bss-compare-list-open-popup',
            description: '',
            showOnEvent: true,
            generatePopupPositionOff: false,
            class: 'bss-popup--product-compare',
            onCoverClickExit: true,
            relativePositionPopup: false,
            recalculatePopupPosition: true,
            showOnStart: false,
            showCover: true,
            closeOnEvent: true,
            imgWaitForLoadingClass: 'wait-loading',
            dynamicText: true,
        },
        {
            componentId: 'containerPopupTermConditions',
            testId: 'containerPopupTermConditions',
            componentTemplate: 'fixedContainerTemplate',
            componentType: 'TemplateComponent',
            containerId: 'popupTermConditions_footer',
            class: 'bss-fixed-container--adjust is-active',
            level: 1,
            order: 4,
            productId: ['general'],
            fixedPosition: true,
            fixedTo: '#popupTermConditions_content',
            dependsTopSelector: '#popupTermConditions_header',
            dependsSelector: '#popupTermConditions_header',
            customEventRecalculatePos: 'bss-popup-showOnEvent-popupTermConditions',
            isInPopup: true,
            modalContainer: '#popupTermConditions_content',
            offHeightCalculation: true,
        },
        {
            componentId: 'buttonClosePopupTermConditions',
            testId: 'buttonClosePopupTermConditions',
            containerId: 'containerPopupTermConditions_content',
            componentType: 'ButtonComponent',
            isPublicEvent: false,
            productId: ['general'],
            level: 1,
            order: 5,
            onClickEvent: 'bss-popup-close-events-popupTermConditions',
            sendEventToServer: false,
            text: "<value data-text='general.confirm_and_close_msg'></value>",
            class: 'bss-button_btn--primary bss-button_btn--inline',
        },
    ];
}
